import React from 'react'
import { usePermission } from 'hooks/usePermission/usePermission'
import { useAppSelector } from 'store/useStoreHook'
import { ModuleNames } from 'interfaces'

export interface ShowProps {
    /** required permission, if it empty array = no permission required */
    when?: number[]
    /** the result when no permission */
    fallback?: any
    /** the result when has permission */
    children?: any
    /** for validate setting of the module is enable */
    moduleName?: ModuleNames
}

export const Show = ({
    when = [],
    fallback,
    children,
    moduleName,
    ...rest
}: ShowProps) => {
    const { hasPermission } = usePermission()

    const show = hasPermission(when)

    const operationSettingData = useAppSelector((state) => state.operation.data)

    const handleOperational = () => {
        if (moduleName) {
            if (operationSettingData[moduleName] !== undefined) {
                return operationSettingData[moduleName]
            }
        }
        return true
    }

    if (show && handleOperational()) {
        return React.Children.map(children, (child) =>
            React.cloneElement(child, rest),
        )
    }

    return fallback || null
}
